import { useLocation } from "react-router-dom";
import { journalUrl, scheduleUrl } from "./adminNav";
import { staffJournalUrl, staffScheduleUrl } from "./staffNav";

export function useHubBasePath() {
  const { pathname } = useLocation();
  return pathname.startsWith("/staff/app") ? "/staff/app" : "/manage/app";
}

export function useHubJournalUrl() {
  const base = useHubBasePath();
  return base === "/staff/app" ? staffJournalUrl : journalUrl;
}

export function useHubScheduleUrl() {
  const base = useHubBasePath();
  return base === "/staff/app" ? staffScheduleUrl : scheduleUrl;
}

export function hubClientsPath(base, patientId) {
  return patientId ? `${base}/clients/${patientId}` : `${base}/clients`;
}

export function usePatientsBase() {
  const base = useHubBasePath();
  return hubClientsPath(base);
}
